import { Shared_PictureResolutions } from "src/backend/openapi/v1";

export const CONSTANTS = {
  DRAWER_WIDTH: 240,
  CONFIGURE_PRODUCT_DRAWER_WIDTH: 400,
  // the arbitrary color a user hasn't picked yet; a neutral white keeps the gradient square's
  // initial thumb position sane (top-left corner) rather than landing on some arbitrary hue
  DEFAULT_PICKER_HEX: "#FFFFFF",
  CUSTOM_EVENT: {
    OPEN_ACCORDION: "OPEN_ACCORDION"
  },
  AUTH_PAGE_QUERY_TYPE: {
    RESET_PASSWORD: "reset-password",
    LOGIN_OTP: "login-otp",
    NEW_PASSWORD: "new-password",
    EMAIL_OTP: "email-otp"
  },
  LOCALSTORAGE_KEYS: {
    CUSTOMER_ID: "deko-customer-id"
  }
};

export const ROUTES_URL = {
  HOME: "/",
  PRICE_LIST: "/price-list",

  INFORMATION: {
    root: "/information",
    pattern: "/information/:currentTab?",
    build: (currentTab: string) => `/information/${currentTab}`
  },
  PROFILE: "/profile",
  CONFIGURATOR: {
    pattern: "/projects/configurator/:projectId",
    build: (projectId: string) => `/projects/configurator/${projectId}`
  },
  CONFIGURE_PRODUCT: {
    pattern: "configure/:configurationId",
    build: (projectId: string, configurationId: string) => `/projects/configurator/${projectId}/configure/${configurationId}`
  },
  // Sibling of CONFIGURE_PRODUCT so it shares the overlay slot; selected ids come from Redux
  BULK_CONFIGURE_PRODUCTS: {
    pattern: "configure/bulk",
    build: (projectId: string) => `/projects/configurator/${projectId}/configure/bulk`
  },
  PROJECTS: "/projects",
  PRODUCT_DETAILS: {
    pattern: "/product-details/:productId",
    build: (productId: string) => `/product-details/${productId}`
  },
  FAQ: "/faq",
  CONTACT: "/contact",
  NOT_FOUND: "/not-found"
};

export const REGEX = {
  containUpperCase: /^(?=.*\p{Lu}).*$/u,
  containsNumber: /^(?=.*\p{N}).*$/u,
  containSpecialCharacter: /^(?=.*[^\p{L}\p{N}]).*$/u
};

export const EXTERNAL_LINKS = {
  DEKO_SUPPORT: "https://deko.support/",
  IMAGE_BANK_ENGLISH: "https://imagebank.deko.com/login/",
  IMAGE_BANK_DANISH: "https://billedbank.deko.dk/login/"
};

export const CACHE_KEYS = {
  CONTACT_PERSON_PICTURE: (contactPersonId: string, resolution: Shared_PictureResolutions) => `CONTACT_PERSON_ID:${contactPersonId}_RESOLUTION:${resolution}`,
  PRODUCT_PICTURE: (pictureId: string) => `PRODUCT_PICTURE_ID:${pictureId}`,
  ALL_PRODUCT_PICTURES: (productId: string, resolution: Shared_PictureResolutions, allPictureIds: string) => `PRODUCT_ID:${productId}_RESOLUTION:${resolution}_PICTURE_IDS:${allPictureIds}`,
  PRODUCTS: (projectId: string, queryString: string) => `PRODUCTS-PROJECTS_ID:${projectId}_QUERY_STRING:${queryString}`,
  PRICE_LIST: (customerId: string, queryString: string) => `PRICE-LIST_ID:${customerId}_QUERY_STRING:${queryString}`
};
